































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import MobileMixin from "@/mixins/mobileMixin";
import ChartsCommon from "@/homeGraph/chartsMixin";
import { MyOptions } from "@/charts/graphData";
import HomeDashboardMobile from "@/layouts/HomeDashboardMobile.vue";
import HomeDashboardDesktop from "@/layouts/HomeDashboardDesktop.vue";
import { DashboardDataService } from "@/services/DashboardDataService";
import { IDashboardData } from "@/types/Dashboard.model";

@Component({
  components: {
    HomeDashboardMobile,
    HomeDashboardDesktop,
  },
})
export default class HomeDashboard extends mixins(
  MyMixin,
  MobileMixin,
  ChartsCommon
) {

  get client(): string {
    return this.$store.getters["getClient"];
  }

  get getGlobal(): boolean {
    return this.$store.getters["getGlobal"];
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }
  public isRunning: boolean = false;
  public dashboardData: IDashboardData = {} as IDashboardData;

  @Prop() public myOptions!: MyOptions;
  @Prop() public isTTC!: boolean;
  private dataService: DashboardDataService = new DashboardDataService();

  @Watch("isTTC")
  public onTTCChanged(newValue: boolean, oldValue: boolean) {
    console.log(`HomeDashboard: isTTC changed from ${oldValue} to ${newValue}, isRunning: ${this.isRunning}`);
    // Ne pas déclencher au premier rendu ou si les valeurs sont identiques
    if (oldValue !== undefined && newValue !== oldValue && !this.isRunning && this.myOptions.site[0] !== undefined) {
      console.log("Triggering TTC reprocess...");
      this.reprocessForTTCChange();
    } else {
      console.log("TTC change ignored - conditions not met");
    }
  }

  @Watch("myOptions.updateMe", { immediate: true, deep: true })
  public onOptionsChanged(value: any, oldValue: any) {
    console.log(`HomeDashboard: updateMe changed to ${value}, isRunning: ${this.isRunning}, site defined: ${this.myOptions.site[0] !== undefined}`);
    if (!this.isRunning && this.myOptions.site[0] !== undefined) {
      console.log("HomeDashboard: Calling init() to reload data from server");
      // Déclencher le loading screen immédiatement AVANT d'appeler init()
      this.$store.dispatch("login/setLoading", true);
      this.init();
    } else {
      console.log("HomeDashboard: Skipping init() - conditions not met");
    }
  }

  public async init() {
    this.isRunning = true;

    try {
      this.dashboardData = await this.dataService.fetchDashboardData(
        this.myOptions,
        this.isTTC,
        this.client,
        this.getGlobal,
        this.enseignes
      );
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      this.isRunning = false;
      this.$store.dispatch("login/setLoading", false);
      this.handleLoaded();
    }
  }

  public handleUpdate(...args: any[]) {
    this.$emit("update", ...args);
  }

  public handleServices(services: string[]) {
    this.$emit("services", services);
  }

  public handleLoaded() {
    this.$emit("loaded");
  }

  public reprocessForTTCChange() {
    console.log(`HomeDashboard: Reprocessing data for TTC change: ${this.isTTC}`);

    // Sauvegarder les valeurs importantes avant le reprocessing
    const previousNbFinished = this.dashboardData.nbFinished;
    const previousReRender = this.dashboardData.reRender;

    const reprocessedData = this.dataService.reprocessDashboardData(
      this.myOptions,
      this.isTTC,
      this.client,
      this.getGlobal,
      this.enseignes
    );

    if (reprocessedData && Object.keys(reprocessedData.CAParService).length > 0) {
      // Préserver les valeurs importantes qui ne doivent pas être réinitialisées
      reprocessedData.nbFinished = previousNbFinished;
      reprocessedData.reRender = !previousReRender;

      // Forcer la réactivité Vue en assignant un nouvel objet
      this.dashboardData = Object.assign({}, reprocessedData);

      // Forcer Vue à détecter le changement
      this.$forceUpdate();
      console.log(`Data reprocessed, CAParService total: ${this.dashboardData.CAParService.TOTAL}, nbFinished: ${this.dashboardData.nbFinished}`);
    } else {
      console.warn("No reprocessed data or empty CAParService");
    }
  }

  public reprocessDataForServiceChange() {
    console.log(`HomeDashboard: Reprocessing data for service change: ${this.myOptions.service}`);
    // Ne pas faire un init() complet, utiliser le reprocessing pour éviter de nouvelles requêtes
    console.log("HomeDashboard - Using reprocessing for service change...");

    // Sauvegarder les valeurs importantes avant le reprocessing
    const previousNbFinished = this.dashboardData.nbFinished;
    const previousReRender = this.dashboardData.reRender;

    const reprocessedData = this.dataService.reprocessDashboardData(
      this.myOptions,
      this.isTTC,
      this.client,
      this.getGlobal,
      this.enseignes
    );

    if (reprocessedData && Object.keys(reprocessedData.CAParService).length > 0) {
      // Préserver les valeurs importantes qui ne doivent pas être réinitialisées
      reprocessedData.nbFinished = previousNbFinished;
      reprocessedData.reRender = !previousReRender;

      // Forcer la réactivité Vue en assignant un nouvel objet
      this.dashboardData = Object.assign({}, reprocessedData);

      // Forcer Vue à détecter le changement
      this.$forceUpdate();
      console.log(`Service data reprocessed - TOTAL: ${this.dashboardData.CAParService.TOTAL}, Service: ${this.myOptions.service}`);
    } else {
      console.warn("No reprocessed data or empty CAParSource for service change");
    }
  }
}
